import { TemplateTabs } from '@aibees/shared/features/advance-table/components/table-layout-modifier-dialog';
import {
  tabPanels,
  tabs,
} from '@aibees/shared/features/advance-table/components/table-layout-modifier-dialog/constants';
import { useTableLayoutTemplateContext } from '@aibees/shared/features/advance-table/components/table-layout-modifier-dialog/context';
import { classnames } from '@aibees/shared/utils';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import {
  Box,
  Stack,
  Tab,
  TabsProps,
  TextField,
  Typography,
} from '@mui/material';
import { memo, SyntheticEvent } from 'react';
import { TableLayoutTemplateList } from '../table-layout-template-list';
import * as Styled from './styles';
import * as SX from './sx';
import type { TableLayoutModifierDialogTabsProps as Props } from './types';

export const TableLayoutModifierDialogTabs = memo(({ className }: Props) => {
  const { handleSearch, tab, setTab, templates } =
    useTableLayoutTemplateContext();

  const handleTabChange: TabsProps['onChange'] = (
    event: SyntheticEvent,
    value: string
  ) => {
    setTab(value as TemplateTabs);
  };

  return (
    <Styled.Wrapper
      className={classnames('TableLayoutModifierDialogTabs', className)}
      sx={SX.root}
    >
      <Stack gap={1}>
        <Typography sx={SX.title}>Layout Templates</Typography>
        <TextField
          size={'small'}
          sx={SX.textfield}
          placeholder="Search Layout Templates"
          onChange={(e) => handleSearch(e.target.value)}
        />
        <Box sx={SX.tabContent}>
          <TabContext value={tab}>
            <TabList onChange={handleTabChange} color="primary">
              {tabs.map((t) => (
                <Tab key={t.value} label={t.label} value={t.value} />
              ))}
            </TabList>
            {tabPanels?.map((t) => (
              <TabPanel key={t.value} value={t.value}>
                <TableLayoutTemplateList items={templates} />
              </TabPanel>
            ))}
          </TabContext>
        </Box>
      </Stack>
    </Styled.Wrapper>
  );
});

TableLayoutModifierDialogTabs.displayName = 'TableLayoutModifierDialogTabs';
